"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const nouislider_react_1 = __importDefault(require("nouislider-react"));
const KeyboardEventCodeEnum_1 = __importDefault(require("@cmd/KeyboardEventCodeEnum"));
const RangeSliderView = ({ values, isDisabled, onChange, name, }) => {
    const [sliderRef, setSliderRef] = (0, react_1.useState)(null);
    const fromInputRef = (0, react_1.useRef)(null);
    const toInputRef = (0, react_1.useRef)(null);
    const activeItems = values.filter((item) => item.active);
    const getFilterFormDataItemValueList = (items) => items.map((item) => Number(item.value));
    const getMin = (items) => Math.min(...getFilterFormDataItemValueList(items));
    const getMax = (items) => Math.max(...getFilterFormDataItemValueList(items));
    const getMinMax = (items) => [getMin(items), getMax(items)];
    const getRange = () => {
        const range = {
            min: getMin(values),
            max: getMax(values),
        };
        values.forEach((item) => {
            if (getMinMax(values).includes(Number(item.value))) {
                return;
            }
            const key = Math.floor((1 / (range.max / Number(item.value))) * 100);
            range[key] = Number(item.value);
        });
        return range;
    };
    const setSliderValuesOnComponentUpdate = (vals) => {
        const [fromValue, toValue] = vals;
        if (fromInputRef.current === null || toInputRef.current === null) {
            return;
        }
        const formatString = (value) => `${Number(value)} měs.`;
        fromInputRef.current.value = formatString(fromValue);
        toInputRef.current.value = formatString(toValue);
    };
    const handleSliderOnChange = (vals) => {
        const selectedItems = values.filter((item) => (Number(item.value) >= Number(vals[0]) && Number(item.value) <= Number(vals[1])));
        onChange(selectedItems, name);
    };
    const removeNonNumericCharacters = (value) => value.replace(/\D+/g, '');
    const removeNonNumericCharactersOnInput = (event) => {
        event.currentTarget.value = removeNonNumericCharacters(event.currentTarget.value);
    };
    const updateRangeSliderOnBlur = (vals) => {
        const [from, to] = vals;
        if (sliderRef === null || sliderRef.noUiSlider === undefined) {
            return;
        }
        sliderRef.noUiSlider.set([from, to]);
        handleSliderOnChange(sliderRef.noUiSlider.get());
    };
    const removeNonNumericCharactersAndSelectAllOnFocus = (event) => {
        const { value } = event.target;
        event.target.value = removeNonNumericCharacters(value);
        event.target.select();
    };
    const handleOnKeyDown = (event) => {
        if (event.key !== KeyboardEventCodeEnum_1.default.ENTER) {
            return;
        }
        event.target.focus();
        event.target.blur();
    };
    (0, react_1.useEffect)(() => {
        if (sliderRef === null || sliderRef.noUiSlider === undefined) {
            return;
        }
        if (activeItems.length > 0) {
            sliderRef.noUiSlider.set(getMinMax(activeItems));
        }
        else {
            sliderRef.noUiSlider.set(getMinMax(values));
        }
    }, [activeItems]);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "range-slider" },
            react_1.default.createElement(nouislider_react_1.default, { instanceRef: (instance) => {
                    if (instance && sliderRef === null) {
                        setSliderRef(instance);
                    }
                }, animate: false, disabled: isDisabled, connect: true, range: getRange(), start: getMinMax(values), snap: true, onUpdate: (vals) => setSliderValuesOnComponentUpdate(vals), onChange: (vals) => handleSliderOnChange(vals) }),
            react_1.default.createElement("div", { className: "range-slider-inputs" },
                react_1.default.createElement("input", { ref: fromInputRef, type: "text", onKeyDown: (event) => handleOnKeyDown(event), onInput: (event) => removeNonNumericCharactersOnInput(event), onBlur: (event) => updateRangeSliderOnBlur([event.target.value, null]), onFocus: (event) => removeNonNumericCharactersAndSelectAllOnFocus(event), disabled: isDisabled, "aria-label": "Doba pron\u00E1jmu od" }),
                "\u00A0",
                react_1.default.createElement("span", null, "\u2013"),
                "\u00A0",
                react_1.default.createElement("input", { ref: toInputRef, type: "text", onKeyDown: (event) => handleOnKeyDown(event), onInput: (event) => removeNonNumericCharactersOnInput(event), onBlur: (event) => updateRangeSliderOnBlur([null, event.target.value]), onFocus: (event) => removeNonNumericCharactersAndSelectAllOnFocus(event), disabled: isDisabled, "aria-label": "Doba pron\u00E1jmu do" }))));
};
exports.default = RangeSliderView;
